var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-shareBox"},[(_vm.toShow)?_c('div',{staticClass:"shareBox-wrap",on:{"click":_vm.noShow}},[_c('img',{staticClass:"shareImg",attrs:{"src":require("../../assets/share_img.png")}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }